import React from "react";
import Link from "@material-ui/core/Link";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";

const styles = theme => ({
  root: {
    marginTop: "8px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit
    }
  },
  link: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    cursor: 'pointer'
  },
  titleBox: {
    marginBottom: theme.spacing.unit / 2
  },
  relatedContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  }
});
class RelatedKeywords extends React.Component {
  handleRelatedClick = (e) => {
    let keyword = e.target.text;
    this.props.search(keyword);
  }

  render() {
    const { classes } = this.props;
    let related = this.props.related;
    return (
      <div className={classes.root}>
        <div className={classes.titleBox}>関連する検索キーワード:</div>
        { related.length > 0 ?
        <div className={classes.relatedContainer}>
          <Icon>search</Icon>
          { related.map((word) =>
            <Link key={word} className={classes.link}
              onClick={this.handleRelatedClick}
            >
            {word}
            </Link> )}
          <span>で検索</span>
        </div>
        : null }
      </div>
    );
  }
}
RelatedKeywords.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RelatedKeywords);
